import { render } from "./RatingSelected.vue?vue&type=template&id=8810e6d6"
import script from "./RatingSelected.vue?vue&type=script&lang=js"
export * from "./RatingSelected.vue?vue&type=script&lang=js"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__